import { IBH_SITES } from './constants'

const siteName = window.ibh?.page?.site || IBH_SITES.IBE
const siteCode = Object.keys(IBH_SITES).find(siteKey => IBH_SITES[siteKey] === siteName)

export const currentSite = {
  name: siteName,
  code: siteCode,
  isMicrosite: siteName !== IBH_SITES.IBE,
  isIberostar: siteName === IBH_SITES.IBE,
  isIbercuba: siteName === IBH_SITES.IBC,
  isIberostarpro: siteName === IBH_SITES.IBP,
  isStaragent: siteName === IBH_SITES.STA,
  isBeachfront: siteName === IBH_SITES.IBF,
  isIndependent: siteName === IBH_SITES.IBH,
}
